<template>
    <div class="overview-summary">
        <ul class="list-group">
            <li
                v-for="item in items"
                :key="item.title"
                class="list-group-item flex-column align-items-start tarief"
            >
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="tarief-intro">
                                <span>{{ item.title }}</span>
                            </div>
                        </div>
                        <div
                            class="col-12 text-right tarief-prijs"
                            :class="{
                                'icon-edit': editable,
                                edit: item.inEdit
                            }"
                            @click="toggleEdit(item)"
                        >
                            <span :class="{ alt: !editable }"
                                >&euro; {{ item.amount }}</span
                            >
                        </div>
                        <div
                            class="col-24 col-sm-12 text-right edit-form"
                            :class="{ edit: item.inEdit }"
                        >
                            <label class="sr-only">{{ item.title }}</label>
                            <input
                                v-model="item.editAmount"
                                class="form-control"
                                type="text"
                            />
                            <button
                                class="btn btn-secondary"
                                @click="updateItem(item)"
                            >
                                OK
                            </button>
                            <a class="link-cancel" @click="toggleEdit(item)"
                                >cancel</a
                            >
                        </div>
                        <div v-if="item.comments" class="col-24">
                            <div
                                v-for="comment in item.comments"
                                :key="comment"
                                class="alert alert-small alert-info"
                            >
                                {{ comment }}
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import RockCurrencyMixin from '@/mixins/RockCurrencyMixin.js';

export default {
    mixins: [RockCurrencyMixin],
    props: ['selectedMonthBonus', 'editable'],
    data() {
        return {
            items: []
        };
    },
    mounted() {
        this.items = [];
        if (this.selectedMonthBonus) {
            for (const costDetail of this.selectedMonthBonus.costsDetails) {
                this.items.push({
                    key: costDetail.account,
                    title: this.getSummaryName(costDetail.account),
                    amount: this.formatCurrency(costDetail.amount),
                    comments: costDetail.comments,
                    inEdit: false
                });
            }
        }
    },
    methods: {
        getSummaryName: function (key) {
            const values = {
                ACCOMODATION: 'Overige vervoers- en verblijfkosten',
                ADVANCE: 'Voorschot bonus',
                CARMAINTENANCE: 'Schade- en onderhoudskosten auto',
                DEVICES: 'Laptop/Telefoon',
                DISCOUNT: 'Betalingskorting',
                EDUCATION: 'Opleidingskosten',
                EXPENSES: 'Declaratie onkostenvergoeding',
                FUEL: 'Brandstof',
                INSURANCE: 'Laptopverzekering',
                INTERMEDIATE: 'Kosten tussenpartij',
                INTERNET: 'Internetvergoeding',
                KILOMETER: 'Gedeclareerde km vergoeding',
                LAPTOP: 'Laptop',
                LEASE: 'Leasekosten',
                NSCARD: 'NS-Business Card',
                OTHERCAR: 'Overige autokosten',
                OTHERS: 'Overige',
                PARKING: 'Parkeerkosten leaseauto',
                PENSION: 'Pensioenbijdrage',
                PHONE: 'Telefoon',
                PUBLICTRANSPORT: 'Gedeclareerde kosten OV',
                REPRESENTATION: 'Declaratie representatiekosten',
                SALARY: 'Bruto loon',
                SOCIALSECURITY: 'Sociale lasten over het loon',
                SUBSCRIPTIONS: 'Abonnementen en literatuur',
                TRAVEL: 'Vergoeding reiskosten',
                VACATION: 'Reservering vakantiegeld',
                VATCAR: 'BTW privégebruik auto',
                WILDCARD: 'Wildcard',
                THIRDPARTY: 'Kosten tussenpartij',
                WORKFROMHOME: 'Thuiswerkvergoeding',
                SECURITYAGENT: 'Security agent',
                ONETIMEPURCHASES: 'Eenmalige aanschaffingen',
                FEMALE: 'Tegemoetkoming female Rockstar',
                WRITEOFF: 'Overige electronica'
            };
            return values[key] || key;
        },
        updateItem: function (item) {
            const amount = this.formatCurrencyToNumber(item.editAmount);
            if (!isNaN(amount)) {
                item.amount = this.formatCurrency(amount);
            }
            this.toggleEdit(item);
            this.$emit('save');
        },
        getUpdatedCosts: function () {
            const updated = {
                costs: 0,
                costsDetails: []
            };
            for (const item of this.items) {
                const newAmount = this.formatCurrencyToNumber(item.amount);
                updated.costsDetails.push({
                    account: item.key,
                    amount: newAmount
                });
                updated.costs += newAmount;
            }
            return updated;
        },
        toggleEdit: function (item) {
            if (this.editable) {
                item.inEdit = !item.inEdit;
                if (item.inEdit) {
                    item.editAmount = item.amount;
                }
            }
        }
    }
};
</script>
